export const datePickerDropdownType = (weekbasis, dateAndTime) => {
    if (weekbasis) {
        return `
        .react-datepicker__week:hover {
            .react-datepicker__day {
            border-radius: 3px;
            color: var(--white-00);
            font-weight: 500;
            background-color: var(--primary);
            }
    `;
    } else if (dateAndTime) {
        return `
            .react-datepicker__week,
            .react-datepicker__day-names {
                display: flex;
                justify-content: space-around;
            }
        
            .react-datepicker__current-month {
                margin: auto;
                width: calc(100% - 70px);
            }
        
            .react-datepicker-popper,
            .react-datepicker {
                width: 100%;
            }
        
            .react-datepicker__day-name,
            .react-datepicker__day,
            .react-datepicker__time-name {
                width: -webkit-fill-available;
            }
        
            .react-datepicker__month-container {
                width: var(--react-datepicker-date-width);
            }
        
            .react-datepicker__time-container {
                width: var(--react-datepicker-time-width);
            }
        `;
    } else return ``;
};
